import React, { useEffect, useState } from 'react';
import { DataShimmer, Helpfull } from '../common';
import Toast from '../common/Toast/Toast';
import { useAppState } from '../../contexts/appState';
import { getContractInfo } from '../../api';
import ContractFaq from './ContractFaq';
import ContractActivation from './ContractActivation/ContractActivation';
import { getContractTypeVal, getCookie, getProjectId, getSourceValue } from '../../lib/common';
import { useLocalStorage, useSessionStorage } from '../../hooks';
import NoDataView from '../../pages/NoDataView';

const ContractHome = () => {
  const [loading, setLoading] = useState(true);
  const [contractResp, setContractResp] = useState({});
  const [appState] = useAppState();
  const source = getSourceValue();
  const [selectedBusiness] = useLocalStorage('selectedBusiness', '');
  const [userDetails] = useSessionStorage('userDetails', '');
  const profile = JSON.parse(sessionStorage.getItem('profileDetails'));
  const selectedBusinessGenio = JSON.parse(localStorage.getItem('selectedBusinessGenio'));
  const projectId = getProjectId();
  const [toastMsg, setToastMsg] = useState({
    message: '',
    status: '',
  });
  const contractVal = getContractTypeVal(projectId);

  useEffect(() => {
    const handleGetContractInfo = async () => {
      try {
        setLoading(true);
        const commonParams = {
          key: 'ContractInformationNew',
          source,
          backUrl: encodeURI(window.location.href),
          projectId,
        };
        let paramsData = {};
        if (projectId === 'csportal') {
          paramsData = {
            ...commonParams,
            docId: selectedBusiness?.docid || '',
            parentId: selectedBusiness?.parentid || '',
            mobile: (userDetails && userDetails?.mobile) || '',
            compName: selectedBusiness?.compname ? encodeURIComponent(selectedBusiness?.compname) : '',
            area: selectedBusiness?.areaname ? encodeURIComponent(selectedBusiness?.areaname) : '',
            city: selectedBusiness?.data_city ? encodeURIComponent(selectedBusiness?.data_city) : '',
            sid: getCookie('sid') || '',
            shortUrl: selectedBusiness?.shorturl || '',
          };
        } else {
          paramsData = {
            ...commonParams,
            docId: selectedBusinessGenio?.docId || '',
            parentId: selectedBusinessGenio?.parentId || '',
            mobile: profile?.mobile || '',
            compName: selectedBusinessGenio?.companyName ? encodeURIComponent(selectedBusinessGenio?.companyName) : '',
            area: selectedBusinessGenio?.location ? encodeURIComponent(selectedBusinessGenio?.location) : '',
            city: selectedBusinessGenio?.city ? encodeURIComponent(selectedBusinessGenio?.city) : '',
          };
        }
        const res = await getContractInfo(paramsData, projectId);
        if (res) {
          setContractResp(res);
        }
        setLoading(false);
      } catch (e) {
        console.log(e);
      }
      setLoading(false);
    };

    handleGetContractInfo();
  }, [selectedBusiness, appState?.csportalData?.docId]);
  return (
    <>
      {loading ? (
        <DataShimmer loading={loading} id="ecsfaq" />
      ) : (
        <>
          {contractResp?.faqDetails?.length > 0 && contractVal !== 'free' ? (
            <>
              <ContractActivation
                contractDetails={contractResp?.contractDetails?.activationData || []}
                contractResp={contractResp}
              />
              <ContractFaq contractData={contractResp || []} />
              <Helpfull redirectkey="contract" />
            </>
          ) : (
            <NoDataView pageName="Contract Information" />
          )}
          {projectId === 'genio' && toastMsg?.message && <Toast toastMsg={toastMsg} setToastMsg={setToastMsg} />}
        </>
      )}
    </>
  );
};

export default ContractHome;
